import React from 'react';
import Filters from './Filters';
import TransactionHistoryTable from './TransactionHistoryTable';
import { TWalletData } from '../types/WalletData';
import useHomeContext from '@/hooks/useHomeContext';
import { SortDirectionEnum, TTransactionHistory } from '../types/TransactionHistory';
import useAuth from '@/hooks/useAuth';
import { useTransactionHistoryV2 } from '../hooks/useTransactionHistoryV2';

interface TransactionHistoryProps {
  onOpenExport: () => void;
  onSelectBankAccount: (selected?: TWalletData) => void;
  alwaysShowFilters?: boolean;
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({
  onOpenExport,
  onSelectBankAccount,
  alwaysShowFilters
}) => {
  const { customer, accountType } = useAuth()!;
  const {
    currentPageTransactions,
    setSelectedTransaction,
    originalTransactionGeneralLedgerCodes,
    archivedTransactionGeneralLedgerCodes
  } = useHomeContext()!;

  const {
    transactionsTotalCount,
    dateSortingDirection,
    setDateSortingDirection,
    currentPage,
    setCurrentPage,
    maxItemsPerPage
  } = useTransactionHistoryV2();

  const handleOnExpandTransaction = (transaction: TTransactionHistory) => {
    setSelectedTransaction(transaction);
  };

  const handleOnSortDateColumn = () => {
    setDateSortingDirection((prev) => {
      return prev === SortDirectionEnum.ASC ? SortDirectionEnum.DESC : SortDirectionEnum.ASC;
    });
  };

  const handleOnPageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="bg-white flex flex-col gap-y-3 overflow-x-visible">
      <div>
        <Filters
          onSelectBankAccount={onSelectBankAccount}
          onOpenExport={onOpenExport}
          alwaysVisible={alwaysShowFilters}
        />
      </div>
      <div>
        <TransactionHistoryTable
          accountType={accountType}
          onExpandDetails={handleOnExpandTransaction}
          onSortDateColumn={handleOnSortDateColumn}
          onPageChange={handleOnPageChange}
          currentPageItems={currentPageTransactions}
          transactionsCount={transactionsTotalCount}
          currentPage={currentPage}
          sortDirection={dateSortingDirection}
          customer={customer}
          maxItemsPerPage={maxItemsPerPage}
          currentGeneralLedgerCodes={originalTransactionGeneralLedgerCodes}
          archivedGeneralLedgerCodes={archivedTransactionGeneralLedgerCodes}
        />
      </div>
    </div>
  );
};

export default TransactionHistory;
